var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-default"},[_c('div',{staticClass:"layout-default__sidebar"},[_c('view-default-sidebar')],1),_c('div',{staticClass:"layout-default__main"},[_c('view-default-header'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }